import { v4 as uuidv4 } from 'uuid'
const generateID = () => uuidv4()

export default generateID
